module.exports = __webpack_public_path__ + "static/media/calculator.95cede46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/calculator.svg
// module id = 880
// module chunks = 21